import React from 'react';

export default function Slider({ label, value, onChange, min = 1, max = 10, lowLabel = 'Low', highLabel = 'High' }) {
  return (
    <div className="space-y-2">
      <div className="flex justify-between items-center">
        <label className="text-sm font-medium text-white/80">{label}</label>
        {value != null && (
          <span className="text-sm font-semibold text-white">{value}/{max}</span>
        )}
      </div>

      <div className="flex gap-1.5">
        {Array.from({ length: max - min + 1 }, (_, i) => i + min).map((n) => (
          <button
            key={n}
            type="button"
            onClick={() => onChange(n)}
            className={`flex-1 h-10 rounded-lg text-xs font-medium transition-all
              ${value === n
                ? 'bg-white text-black shadow-sm scale-105'
                : 'bg-white/10 text-white/50 hover:bg-white/20'
              }`}
          >
            {n}
          </button>
        ))}
      </div>

      <div className="flex justify-between text-xs text-white/40">
        <span>{lowLabel}</span>
        <span>{highLabel}</span>
      </div>
    </div>
  );
}
